import Vue from 'vue'
import router from '@/router'
//导入ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
//全局自定义样式
import '@/css/custom.css'
import '@/css/css3-flex.css'
//弹窗拖动指令
import '@/js/drag.js'
//axios请求
import axios from '@/js/http'
import qs from 'qs'
//公共方法
import utils from '@/js/utils'
//主页入口
import App from '@/App'
//安装ElementUI
Vue.use(ElementUI)

//绑定axios到Vue
Vue.prototype.$axios = axios
//绑定qs到Vue
Vue.prototype.$qs = qs
//公共方法
Vue.prototype.$utils = utils

Vue.config.productionTip = false

// 设置全局变量
Vue.prototype.$BASE_URL = 'http://qcldtestapi.gongyouba.com/images'

new Vue({
  el: '#app',
  //启用路由
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js